import { render, staticRenderFns } from "./ProductsListing.vue?vue&type=template&id=079a8dc0&"
import script from "./ProductsListing.vue?vue&type=script&lang=js&"
export * from "./ProductsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductsListing.vue"
export default component.exports